import { api } from '../../core/network/api';

/**
 * Worlds ("instances") — see design/gdd/multi-world.md. There is no global
 * map: every map read is scoped to one world, and a player's colonies all
 * live in the same one.
 */

export type WorldStatus = 'UPCOMING' | 'OPEN' | 'CLOSING' | 'ARCHIVED';

export interface WorldSummary {
  id: string;
  number: number;
  name: string;
  status: WorldStatus;
  startsAt: string;
  endsAt: string;
  playerCount: number;
  maxPlayers: number;
  gridWidth: number;
  gridHeight: number;
  /** Server's verdict: OPEN and below the player cap. Never recomputed here. */
  joinable: boolean;
}

/** GET /worlds — every world, including the ones no longer accepting players. */
export async function fetchWorlds(): Promise<WorldSummary[]> {
  return api.get<WorldSummary[]>('/worlds');
}

/** GET /worlds/joinable — what the world picker offers a new player. */
export async function fetchJoinableWorlds(): Promise<WorldSummary[]> {
  return api.get<WorldSummary[]>('/worlds/joinable');
}
